import { Route, Routes } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Home from "./page/home";
import Login from "./page/Login";
import Signup from "./page/Signup";
import Forget from "./page/Forget";
import Error from "./page/Error";
import Accomplish from "./page/Accomplish";
import Dashboard from "./Dashboard/dashboard";
import DailerCalling from "./Dashboard/DashboardComponents/Dialer/DailerCalling/DailerCalling";
import NeedHelp from "./Dashboard/needHelp";
import OwnAgentCalling from "./Dashboard/DashboardComponents/OwnAgents/ownAgentCalling";
import ChatBot from "./Dashboard/DashboardComponents/chatBot/ChatBot";
import BlogContent from "./components/home/homecomponent/blogFolder/blogContent";
import BlogEffortless from "./components/home/homecomponent/blogFolder/blogEffortless";
import BlogMasterful from "./components/home/homecomponent/blogFolder/blogMasterful";
import ScratchScript from "./Dashboard/DashboardComponents/Agents/scratchScript";
//import LoaderScreen from "./Dashboard/DashboardComponents/Dialer/LoaderScreen";
// import { socket } from "./Socket";
import { useEffect } from "react";
import SingleAgent from "./Dashboard/DashboardComponents/SingleAgent/SingleAgent";
import axios from "axios";

function App() {
  var authToken = JSON.parse(localStorage.getItem("bearerToken"));

  useEffect(() => {
    const newSocket = new WebSocket("wss://gpd-production.onrender.com/ws");

    newSocket.onopen = (event) => {
      console.log("WebSocket connection opened:", event);
      const initialMessage = "Hello, WebSocket!";
      newSocket.send(initialMessage);
    };

    newSocket.onmessage = async (event) => {
      const message = event.data;
      const data = await JSON.parse(message);
      console.log(data);
      console.log(typeof data);
    };

    return () => {
      newSocket.close();
    };
  }, []);

 

  return (
    <div className="App">
      <ToastContainer />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/accomplish" element={<Accomplish />} />
        <Route path="/blogContent" element={<BlogContent />} />
        <Route path="/blogEffortless" element={<BlogEffortless />} />
        <Route path="/blogMasterful" element={<BlogMasterful />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forget" element={<Forget />} />
        <Route path="/error" element={<Error />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/dialer/calling" element={<DailerCalling />} />
        <Route path="/aicall" element={<OwnAgentCalling />} />
        <Route path="/needHelp" element={<NeedHelp />} />
        <Route path="/chatbot" element={<ChatBot />} />
        <Route path="/scratchScript" element={<ScratchScript />} />
        <Route path="/singleagent" element={<SingleAgent />} />
        {/* <Route path="/loader" element={<LoaderScreen />} /> */}
      </Routes>
    </div>
  );
}

export default App;
